import React, { useEffect, useState, useMemo } from 'react';
import { Button, Spin } from 'antd';
import { Table, Modal } from 'antd';
import style from './index.scss';
import {
  PlusCircleOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import AddRuleModal from './AddRuleModal';
import { getTableColumns } from './util.js';
import { cloneDeep } from '../../../../../../util/lodashlike';

const { confirm } = Modal;
function RiskIndicators({
  isLoading,
  riskIndicatorsState,
  setRiskIndicatorData,
  riskIndicatorsData,
  handRiskIndicatorsWeightAge,
  disabled,
  isDeployProduction,
  deployedRiskIndicators,
  resetCount
}) {
  const Loading = isDeployProduction ? false : isLoading;
  const [addRuleVisible, setAddRuleVisible] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [weightAge, setWeightAge] = useState(0);
  const [weightAgeMessage, setWeightAgeMessage] = useState(true);

  const handleDeleteRI = (record) => {
    let records = cloneDeep(tableData);
    const deleteRule = records.find((data) => data.name === record.name);
    const newFilteredData = records.filter(
      (obj) => obj.name !== deleteRule.name
    );
    setTableData(newFilteredData);
    setRiskIndicatorData(newFilteredData);
  };

  const handleDeleteRuleConfirm = (record) => {
    confirm({
      title: 'Delete Risk Indicator',
      icon: <ExclamationCircleOutlined />,
      content: 'Are you sure you want to delete the risk indicator?',
      onOk: () => {
        handleDeleteRI(record);
      },
      onCancel: () => {
        console.log('Cancel');
      },
      okText: 'Delete',
      width: 450
    });
  };

  const handleWeightUpdate = (value, record) => {
    let records = cloneDeep(tableData);
    let index = records.findIndex((r) => r.name === record.name);
    if (index >= 0) {
      records[index].weight = value;
    }
    setTableData(records);
    setRiskIndicatorData(records);
  };

  useEffect(() => {
    if (!isDeployProduction && riskIndicatorsData)
      setTableData(riskIndicatorsData);
    else setTableData(deployedRiskIndicators);
  }, [riskIndicatorsData, deployedRiskIndicators]);

  useEffect(() => {
    setWeightAge(0);
  }, [resetCount]);

  useMemo(() => {
    if (!isDeployProduction) {
      let totalWeight = 0;
      let emptyRI = 0;
      tableData?.forEach((ri) => {
        totalWeight += ri?.weight ? parseFloat(ri?.weight) : 0;
        emptyRI += ri?.weight && ri?.weight > 0 ? 0 : 1;
      });

      setWeightAge(totalWeight);
      handRiskIndicatorsWeightAge(totalWeight === 100 && emptyRI === 0);
      if (totalWeight !== 100 || emptyRI !== 0) {
        setWeightAgeMessage(true);
      } else {
        setWeightAgeMessage(false);
      }
    }
  }, [tableData]);

  return (
    <Spin spinning={isLoading}>
      <div className={style.createTable} style={{ marginTop: '30px' }}>
        {!isDeployProduction && (
          <p>
            Total weightage - {weightAge}/100
            {weightAgeMessage && (
              <span style={{ marginLeft: '10px', color: 'red' }}>
                Sum of all the riskindicators weight should be 100%
              </span>
            )}
          </p>
        )}
        <Table
          className={style.table}
          dataSource={tableData}
          columns={getTableColumns(
            Loading,
            tableData,
            riskIndicatorsState,
            handleDeleteRuleConfirm,
            handleWeightUpdate,
            disabled
          )}
          rowKey={(row) => row.name}
          footer={() =>
            !isDeployProduction && (
              <div className={classNames(style.footer, style.marginedFooter)}>
                <Button
                  type="text"
                  icon={<PlusCircleOutlined className={style.addIcon} />}
                  disabled={disabled}
                  onClick={() => {
                    setAddRuleVisible(true);
                  }}>
                  Add Rule
                </Button>
                <AddRuleModal
                  addRuleVisible={addRuleVisible}
                  onCancel={setAddRuleVisible}
                  riskIndicatorsState={riskIndicatorsState}
                  isLoading={isLoading}
                  tableData={tableData}
                  setTableData={setTableData}
                  setRiskIndicatorData={setRiskIndicatorData}
                />
              </div>
            )
          }
        />
      </div>
    </Spin>
  );
}

RiskIndicators.propTypes = {
  isLoading: PropTypes.bool,
  riskIndicatorsState: PropTypes.array,
  setRiskIndicatorData: PropTypes.func,
  riskIndicatorsData: PropTypes.array,
  handRiskIndicatorsWeightAge: PropTypes.func,
  disabled: PropTypes.bool,
  resetCount: PropTypes.number
};

export default RiskIndicators;
